import { defineComponent, computed, inject } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UiAssetClassBadge",
  props: {
    locale: { type: null, required: true },
    assetClass: { type: null, required: false, default: "generic" }
  },
  setup(__props) {
    const props = __props;
    const assetBadgeClass = computed(() => {
      return `fds-ui-asset-class-badge--${props.assetClass}`;
    });
    const localizationSupport = useLocalizationSupport(props, {
      translator: inject("translator"),
      numberFormatter: inject("numberFormatter"),
      dateFormatter: inject("dateFormatter")
    });
    const { translate } = localizationSupport;
    return { __sfc: true, props, assetBadgeClass, localizationSupport, translate };
  }
});

export { _sfc_main as default };
